module.exports = __webpack_public_path__ + "static/media/rakesh.bc31c846.jpeg";